export default {
  chatrooms: {}
}
